<div
  (click)="selectField.emit(index)"
  class="group relative flex items-start gap-3 p-3.5 rounded-xl border-2 bg-white dark:bg-gray-900 cursor-pointer transition-all"
  [class.border-brand-500]="isSelected"
  [class.shadow-sm]="isSelected"
  [class.border-gray-200]="!isSelected"
  [class.dark:border-gray-700]="!isSelected"
  [class.hover:border-gray-300]="!isSelected"
  [class.dark:hover:border-gray-600]="!isSelected"
>
  <!-- Drag handle -->
  <div cdkDragHandle class="flex-shrink-0 mt-0.5 cursor-grab text-gray-300 hover:text-gray-500 dark:text-gray-600 dark:hover:text-gray-400 transition-colors">
    <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
      <circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/>
      <circle cx="9" cy="12" r="1.5"/><circle cx="15" cy="12" r="1.5"/>
      <circle cx="9" cy="19" r="1.5"/><circle cx="15" cy="19" r="1.5"/>
    </svg>
  </div>

  <!-- Icon -->
  <span
    class="flex-shrink-0 w-5 h-5 mt-0.5 [&>svg]:w-full [&>svg]:h-full [&>svg]:block transition-colors"
    [class.text-brand-500]="isSelected"
    [class.text-gray-400]="!isSelected"
    [innerHTML]="getIcon() | safeHtml"
  ></span>

  <!-- Content -->
  <div class="flex-1 min-w-0">
    <div class="flex items-center gap-1.5">
      <span class="text-sm font-medium text-gray-800 dark:text-white/90 truncate">
        {{ field.label || '(sin etiqueta)' }}
      </span>
      @if (field.isRequired) {
        <span class="text-error-500 text-sm font-bold leading-none">*</span>
      }
      @if (field.isHidden) {
        <span class="text-[10px] px-1.5 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 font-medium">oculto</span>
      }
    </div>
    <p class="text-xs text-gray-400 dark:text-gray-500 mt-0.5 truncate">
      {{ field.placeholder || field.fieldType }}
    </p>
  </div>

  <!-- Delete button (solo nuevos o si es Admin) -->
  @if (canRemove) {
    <button
      (click)="removeField.emit(index); $event.stopPropagation()"
      class="flex-shrink-0 opacity-0 group-hover:opacity-100 inline-flex items-center justify-center w-6 h-6 rounded-lg text-gray-400 hover:text-error-500 hover:bg-error-50 dark:hover:bg-error-500/10 transition-all"
      title="Eliminar campo"
    >
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  }

  <!-- Drag placeholder — direct child of cdkDrag so CDK finds it correctly -->
  <div *cdkDragPlaceholder class="h-14 w-full rounded-xl bg-brand-50 dark:bg-brand-500/10 border-2 border-dashed border-brand-300 dark:border-brand-500/40"></div>
</div>
